/* eslint-disable no-restricted-imports */
import React from 'react';
import styles from './content-tiers.module.css';
import {IContentTierBenefit} from '../../types/contentTiers.types';
import classnames from 'classnames';
import Markdown from 'markdown-to-jsx';
import {PRICE_VARIABLE} from '../../types';

interface IBenefitsComponentProps {
    benefit: IContentTierBenefit;
    showPlanUI?: boolean;
    annualSavingsWithMonthly?: string;
    annualSavingsWithInstallment?: string;
    version?: string;
    priceToShow?: string
}

const BenefitsComponent: React.FC<IBenefitsComponentProps> = ({
    benefit,
    showPlanUI = false,
    annualSavingsWithInstallment = '',
    annualSavingsWithMonthly = '',
    version = 'v1',
    priceToShow = ''
}) => {
    let benefitValue = benefit?.value;
    if (priceToShow && benefit?.value.includes(PRICE_VARIABLE)) {
        benefitValue = benefit?.value?.replace(PRICE_VARIABLE, priceToShow);
    } else {
        benefitValue = benefit?.value
            ?.replace(
                /\{annualSavingsWithInstallment\}/g,
                `${annualSavingsWithInstallment}`
            )
            ?.replace(
                /\{annualSavingsWithMonthly\}/g,
                `${annualSavingsWithMonthly}`
            );
    }

    return (
        <div
            className={classnames(styles.benefitItem, {
                [styles.benefitItemDisabled]: benefit.disabled,
                [styles.benefitItemNewUI]: showPlanUI,
                [styles.benefitItemBoxingPage]: version !== 'v1'
            })}
        >
            {benefit.iconName && <img alt="icon" src={benefit.iconUrl} />}

            <Markdown
                className={classnames({
                    [styles.applyBold]:
                        benefitValue.includes('<b>') &&
                        benefitValue.includes('</b>'),
                    [styles.applyDisable]:
                        benefitValue.includes('<d>') &&
                        benefitValue.includes('</d>'),
                    [styles.applyStrikeOff]:
                        benefitValue.includes('<s>') &&
                        benefitValue.includes('</s>'),
                    [styles.applyItalic]:
                        benefitValue.includes('<i>') &&
                        benefitValue.includes('</i>')
                })}
            >
                {benefitValue}
            </Markdown>
        </div>
    );
};

export default BenefitsComponent;
